import React from 'react';
import ThemeProvider from 'components/qr-code-menu/theme-provider';
import PropTypes from 'prop-types';

import { Box, Container } from '@mui/material';
import { alpha } from '@mui/material/styles';

import { bgGradient, bgBlur } from 'theme/css';
import { Spinner } from 'components/spinner';

// ----------------------------------------------------------------------

export default function BackgroundLayout({ isLoading, menuTheme, children, sx, ...other }) {
  if (isLoading) {
    return <Spinner />;
  }

  return (
    <ThemeProvider menuTheme={menuTheme}>
      <Box
        sx={{
          height: '100vh',
          ...sx,
        }}
        {...other}
      >
        <Box
          sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            pointerEvents: 'none',
            ...bgGradient({
              color: alpha(menuTheme.background, 0.3),
              imgUrl: menuTheme.backgroundImage,
            }),
          }}
        >
          <Box
            sx={{
              height: 1,
              display: 'flex',
              flexDirection: 'column',
              ...bgBlur({
                color: menuTheme.background,
                opacity: 0.2,
              }),
            }}
          >
            <Container
              sx={{
                height: 1,
                position: 'relative',
                backgroundColor: menuTheme.background || '#f0f0f0',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                zIndex: -1,
              }}
            >
              {menuTheme.backgroundImage && (
                <img
                  src={menuTheme.backgroundImage}
                  alt="background"
                  style={{
                    width: '100vw',
                    height: '100vh',
                    objectFit: 'cover',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                  }}
                />
              )}
            </Container>
          </Box>
        </Box>
        <Box
          component="main"
          sx={{
            position: 'relative',
            height: 1,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Container
            sx={{
              height: 1,
              p: '0 !important',
            }}
          >
            <Box
              sx={{
                height: 1,
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              {children}
            </Box>
          </Container>
        </Box>
      </Box>
    </ThemeProvider>
  );
}

BackgroundLayout.propTypes = {
  children: PropTypes.node,
};
